export const entertraimentActions = {
  result: {
    title: 'Dg.loader.result.title',
    subtitle: 'Dg.loader.result.subtitle',
    progress: 10000,
    nexType: 'sat',
  },
  sat: {
    title: 'Dg.loader.sat.title',
    subtitle: 'Dg.loader.sat.subtitle',
    progress: 10000,
    nexType: 'complications',
  },
  complications: {
    title: 'Dg.loader.complications.title',
    subtitle: 'Dg.loader.complications.subtitle',
    progress: 10000,
    nexType: 'click',
  },
  click: {
    title: 'Dg.loader.click.title',
    subtitle: 'Dg.loader.click.subtitle',
    progress: 10000,
    nexType: 'mexicans',
  },
  mexicans: {
    title: 'Dg.loader.mexicans.title',
    subtitle: 'Dg.loader.mexicans.subtitle',
    progress: 10000,
    nexType: 'result',
  },
};
